"use client";
import { Col, Row, Card, Tag, Button, Typography } from "antd";
import { wrapperRouterPush } from "@/src/util/util";

import "@/src/style/knowledge-dt.css";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from "next/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import "@/src/style/common.css";
import "../home/diary-home.scss";
import ImageCommon from "../image/image";

const { Title } = Typography;

export default function DiaryDoctor(props) {
  const { diaryData } = props;
  const parseArray = diaryData.reduce((result, value, index, array) => {
    if (index % 4 === 0) {
      result.push(array.slice(index, index + 4));
    }
    return result;
  }, []);

  const router = useRouter();
  return (
    <div className={`wp-knowledgeDentistry wp-showcase-home`}>
      <div className="wp-content-diary-home">
        <Swiper
          slidesPerView={1}
          // autoplay={{
          //   delay: 4000,
          //   disableOnInteraction: false,
          // }}
          loop={true}
          pagination={{
            clickable: true,
          }}
          scrollbar={true}
          modules={[Autoplay, Pagination, Navigation]}
        >
          {parseArray?.map((item) => (
            <SwiperSlide>
              <div className="wp-perview">
                <Row gutter={[12, 12]}>
                  {item?.map((subItem) => {
                    return (
                      <Col xl={12} md={12}>
                        <div
                          onClick={() => {
                            wrapperRouterPush(
                              router,
                              `/showcase/${subItem.slug}`
                            );
                          }}
                          className="wp-contentItem"
                        >
                          <Card className="content">
                            <Row className={"cusRow"}>
                              <Col
                                xs={24}
                                lg={11}
                                xl={10}
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  height: "100%",
                                }}
                              >
                                {(() => {
                                  const filterTimeStart =
                                    subItem.dental_condition.filter(
                                      (filteredTime) =>
                                        filteredTime.type === "START"
                                    )[0];
                                  const filterTimeEnd = subItem.dental_condition
                                    .filter(
                                      (filteredTime) =>
                                        filteredTime.type !== "START"
                                    )
                                    .pop();
                                  return (
                                    <>
                                      {filterTimeStart && (
                                        <div className="even-clum">
                                          <ImageCommon
                                            data={filterTimeStart.image[0]}
                                            style="processImg"
                                          />
                                          <Tag className="timeBracess">
                                            Trước
                                          </Tag>
                                        </div>
                                      )}

                                      {filterTimeEnd && (
                                        <div
                                          className="even-clum"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          <ImageCommon
                                            data={filterTimeEnd.image[0]}
                                            style="processImg"
                                          />
                                          <Tag className="timeBracess">Sau</Tag>
                                        </div>
                                      )}

                                      {!filterTimeEnd && filterTimeStart && (
                                        <div
                                          className="even-clum"
                                          style={{ marginLeft: "10px" }}
                                        >
                                          <ImageCommon style="processImg" />
                                        </div>
                                      )}

                                      {!filterTimeStart && !filterTimeEnd && (
                                        <>
                                          <div className="even-clum">
                                            <ImageCommon style="processImg" />
                                          </div>
                                          <div
                                            className="even-clum"
                                            style={{ marginLeft: "10px" }}
                                          >
                                            <ImageCommon style="processImg" />
                                          </div>
                                        </>
                                      )}
                                    </>
                                  );
                                })()}
                              </Col>
                              <Col xl={14} xs={24} lg={17}>
                                <div className="space-content">
                                  <div>
                                    <Title
                                      className="nameShowcase mb-7"
                                      level={4}
                                    >
                                      {subItem.title}
                                    </Title>
                                    <div className="category">
                                      <strong>Dịch vụ: </strong>
                                      {subItem.category_service.name}
                                    </div>

                                    <div className="category">
                                      <strong>Loại niềng: </strong>
                                      {/* {subItem.category_service.name} */}
                                    </div>

                                    <div className="category">
                                      <strong>Thời gian hoàn thành: </strong>
                                      {subItem.duration_time > 0
                                        ? subItem.duration_time + " tháng"
                                        : null}
                                    </div>
                                  </div>
                                  <Link href={`/showcase/${subItem.slug}`}>
                                    <Button className="btnDetail">
                                      Xem chi tiết
                                    </Button>
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
